export enum HomeAPIRoutes {
    GET_USER_INFO = "auth:users:info"
}
